import React from "react";
import styles from "./StatusDropdownContent.module.css";

export const StatusDropdownContent = (props) => {
    return (
        <div className={props.open ? styles.contentOpen : styles.contentClosed}>
            {props.open ? props.content : null}
        </div>
    );
}